<template>
  <div>
    <e-dialog
      :dialog-title="title"
      :center-dialog-visible="applyForInvoiceVisible"
      :showCloseBtn="showCloseBtn"
      :showBtn="showBtn"
      popup-width="800px"
      :closeBtn="true"
      @resetPopupData="handleClose"
      @submitPopupData="submitPopupData"
      buttonTip="申请开票"
    >
      <el-form ref="form" :model="formData" :rules="formData.invoiceType === 2 ? rules :{}" label-width="120px">
        <el-form-item label="发票类型:" prop="invoiceType">
          <el-radio-group
            v-model="formData.invoiceType"
            @change="changeInvoiceType"
            :disabled="!showBtn"
          >
            <el-radio :label="1">增值税普通发票（电子发票）</el-radio>
            <el-radio :label="2">增值税专用发票（电子发票）</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="formData.invoiceType === 1 && title === '查看发票信息' ">
          <el-form-item label="发票下载地址:">
            <eui-link font-size="14px" lighten color="#0064c8" @click="handleDown" v-if="formData.fileUrl">
               点击下载
            </eui-link>
          </el-form-item>
        </div>
        <div class="tip" v-if="formData.invoiceType === 1 && title === '申请开票'">
          <span style="color: #f0250f">请注意：</span
          >电子发票会根据发生交易时的公司信息作为发票抬头
        </div>
        <div v-if="formData.invoiceType === 2">
          <el-form-item label="发票抬头:" prop="customer">
            <el-select
              v-model="formData.customer"
              placeholder="请选择"
              style="width: 530px; height: 30px"
              @change="changeCustomer"
              :disabled="!showBtn"
              popper-class="select-popper"
            >
              <el-option
                v-for="item in customerOptions"
                :key="item.invoiceId"
                :label="item.label"
                :value="item.invoiceId"
              >
              </el-option>
            </el-select>
            <eui-btn type="text" class="margin-l10"  color="#0064c8,#004898,#004898" @click="toCreate('/user/user/invoiceManagement')" v-if="title === '申请开票'">创建发票抬头</eui-btn>
          </el-form-item>
          <el-form-item label="纳税人识别号:">{{ formData.TIN }}</el-form-item>
          <el-form-item label="开户行:"> {{ formData.bank }}</el-form-item>
          <el-form-item label="银行账号:">{{
            formData.bankAccount
          }}</el-form-item>
          <el-form-item label="注册地址:">{{
            formData.regAddress
          }}</el-form-item>
          <el-form-item label="注册电话:"
            >{{ formData.regPhone }}
          </el-form-item>
          <el-form-item label="发票邮寄地址:" prop="address">
            <el-select
              v-model="formData.address"
              placeholder="请选择"
              style="width: 530px; height: 30px"
              @change="changeAddress"
              :disabled="!showBtn"
              popper-class="select-popper"
            >
              <el-option
                v-for="item in addressOptions"
                :key="item.addressId"
                :label="item.label"
                :value="item.addressId"
              >
              </el-option>
            </el-select>
            <eui-btn type="text" class="margin-l10"  color="#0064c8,#004898,#004898" @click="toCreate('/user/user/myAddress')" v-if="title === '申请开票'">创建邮寄地址</eui-btn>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系人:">{{
                formData.receiveName
              }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话:">{{
                formData.receivePhone
              }}</el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </e-dialog>
  </div>
</template>

<script>
import eDialog from '../../../components/common/e-dialog';
import api from '@/modules/projectA/api/pay';
import Api from '@/modules/projectA/api/user';
import { epecMallUrl } from '@/modules/projectA/api/config';
export default {
  name: 'applyForInvoiceDialog',
  components: {
    eDialog,
  },
  props: {
    applyForInvoiceVisible: Boolean,
    recordMonthIdList:Array,
    title: {
      type: String,
      default: '申请开票'
    }
  },
  data() {
    return {
      showCloseBtn:false,
      showBtn:true,
      customerOptions: [],
      addressOptions:[],
      formData: {
        invoiceType: 1, //发票类型
        bank:'',//开户行
        customer: '', //发票抬头
        TIN: '', //纳税人识别号
        bankAccount: '', //银行账号
        regAddress: '', //注册地址
        regPhone: '', //注册电话
        receiveName: '', //联系人
        receivePhone: '', //联系电话
        address:'',//发票邮寄地址
        recordMonthIdList:[]
      },
      rules: {
        customer: [{ required: true, message: '请选择发票抬头', trigger: 'change' }],
        address: [{ required: true, message: '请选择发票邮寄地址', trigger: 'change' }],
      },
      commonInvoiceData: [], //增值税普通发票
      specialInvoiceData: [], //增值税专用发票
    };
  },
  methods: {
    handleDown(){
      let a = document.createElement("a"); //创建一个<a></a>标签
      a.href = this.formData.fileUrl; // 给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
      a.download = "黑名单导入模板.xls"; //设置下载文件文件名，这里加上.xls指定文件类型，pdf文件就指定.fpd即可
      a.style.display = "none"; // 障眼法藏起来a标签
      document.body.appendChild(a); // 将a标签追加到文档对象中
      a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove(); // 一次性的，用完就删除a标签
    },
    toCreate(path){
      window.open(`${epecMallUrl}${path}`);
    },
    changeAddress(val){
      const item = this.addressOptions.filter(item=>Number(item.addressId) === val)[0];
      this.formData.address = item.detailAddress;
      this.formData.receiveName = item.realName;
      this.formData.receivePhone = item.mobile;
    },
    //解决不同key
    changeCustomer(val){
      const item = this.customerOptions.filter(item=>Number(item.invoiceId) === val)[0];
      this.formData.TIN = item.identificationNumber ;
      this.formData.bankAccount = item.bankAccount ;
      this.formData.bank = item.bank ;
      this.formData.regAddress = item.address ;
      this.formData.regPhone = item.telephone ;
      this.formData.customer = item.title ;
    },
    changeInvoiceType(val) {
      if (val === 101) {
        this.customerOptions = this.commonInvoiceData;
      } else {
        this.customerOptions = this.specialInvoiceData;
      }
      //清空数据
      this.clearData();
    },
    clearData(){
      this.formData.customer = '';
      this.formData.TIN = '';
      this.formData.bankAccount =  '' ;
      this.formData.bank =  '' ;
      this.formData.regAddress =  '' ;
      this.formData.regPhone =  '' ;
      this.formData.address = '';
      this.formData.receiveName = '';
      this.formData.receivePhone = '';
    },
    async submitPopupData(){
      this.formData.recordMonthIdList = this.recordMonthIdList;
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.applyPaymentInvoice();
        }
      })
    },
    async applyPaymentInvoice(){
      const res = await api.applyPaymentInvoice(this.formData);
      if (res.success) {
        this.$message.success('操作成功');
        this.handleClose();
        this.$parent.zhongJinQueryPage();
        this.$parent.clearSelected();
        this.$emit('update:recordMonthIdList', []);
        this.$emit('update:selectData', []);
      }
    },
    handleClose() {
      this.$emit('update:applyForInvoiceVisible', false);
    },
    // 查询用户全部发票     101 : 增值税普通发票;   102 :增值税专用发票
    async queryInvoiceList() {
      const res = await Api.queryInvoiceList();
      if (res.success) {
        const data = res.data || [];
        data.forEach(item=>{
          item.label = item.title + '   ' +  String(item.identificationNumber);
        })
        this.commonInvoiceData = data.filter(item => Number(item.invoiceType) === 101);
        this.specialInvoiceData = data.filter(item => Number(item.invoiceType) === 102);
        this.customerOptions = this.specialInvoiceData;
      }
    },
    // 查询用户全部发票邮寄地址
    async invoiceAddressList() {
      const res = await Api.invoiceAddressList();
      if (res.success) {
        const data = res.data || [];
        data.forEach(item=>{
          item.label = item.detailAddress + ' ' + item.realName + '收';
        })
        this.addressOptions = data;
      }
    },
    async paymentInvoiceDetail(){
      const res = await api.paymentInvoiceDetail({invoiceId:this.recordMonthIdList[0]});
      if (res.success) {
          this.formData = res.data;
      }
    },
  },
  mounted() {
    this.queryInvoiceList();
    this.invoiceAddressList();
    if(this.title === '查看发票信息'){
      this.paymentInvoiceDetail();
      this.showBtn = false;
    }
  },
};
</script>

<style scoped lang="scss">
.tip {
  width: 760px;
  height: 44px;
  line-height: 44px;
  padding-left: 10px;
  background-color: #e8efff;
}
::v-deep .el-radio__inner {
  width: 16px;
  height: 16px;
}
::v-deep .el-radio__inner::after {
  width: 6px;
  height: 6px;
}
::v-deep .el-form-item--small.el-form-item {
  margin-bottom: 10px;
}
::v-deep .el-form-item {
  margin-bottom: 0;
}
.select-popper .el-select-dropdown__item{
  width: 650px;
  white-space:normal;
  word-break: break-all;
  height: auto;
  overflow: visible;
}
</style>
